import { render } from "./ProductPlatformUploadButtonList.vue?vue&type=template&id=03fce01e"
import script from "./ProductPlatformUploadButtonList.vue?vue&type=script&lang=js"
export * from "./ProductPlatformUploadButtonList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__